import Instance from './instance.js'

/**
 * Represents a InstanceNumber instance.
 * @extends Instance
 */
class InstanceNumber extends Instance {
}

export default InstanceNumber
